class ConflictError extends Error {

    constructor(message) {
        super(message)
        this.name = 'ConflictError'
        this.message = message || 'A conflict (409) has occurred'
        this.stack = (new Error()).stack
    }
}

export default ConflictError
